import { useMemo, useState } from "react";

import type { Cinema } from "../types";
import { Dialog } from "./Dialog";

/** « comedie » doit trouver « Pathé Comédie » : on compare sans accents ni casse. */
export const fold = (text: string) =>
  text
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .trim()
    .toLowerCase();

type Props = {
  cinemas: Cinema[];
  current: Cinema | null;
  onSelect: (cinema: Cinema) => void;
  onClose: () => void;
};

export function CinemaPicker({ cinemas, current, onSelect, onClose }: Props) {
  const [query, setQuery] = useState("");

  const matches = useMemo(() => {
    const needle = fold(query);
    if (!needle) return cinemas;
    return cinemas.filter((cinema) => fold(`${cinema.name} ${cinema.city}`).includes(needle));
  }, [cinemas, query]);

  return (
    <Dialog title="Choisir un cinéma" subtitle={`${cinemas.length} cinémas Pathé`} onClose={onClose}>
      <input
        className="search-field"
        type="search"
        autoFocus
        placeholder="Rechercher par nom ou par ville…"
        value={query}
        onChange={(event) => setQuery(event.target.value)}
      />

      {matches.length === 0 ? (
        <p className="state" style={{ padding: "30px 0", textAlign: "center" }}>
          Aucun cinéma ne correspond à « {query} ».
        </p>
      ) : (
        <ul className="cinema-list">
          {matches.map((cinema) => (
            <li key={cinema.slug}>
              <button
                type="button"
                className={cinema.slug === current?.slug ? "cinema-item is-current" : "cinema-item"}
                onClick={() => onSelect(cinema)}
              >
                <span>
                  <span className="cinema-item-name">{cinema.name}</span>
                  <span className="cinema-item-meta">
                    {cinema.city} · {cinema.hallCount} salles · {cinema.seatCount} pl.
                  </span>
                </span>
                {cinema.slug === current?.slug && <span className="dot">●</span>}
              </button>
            </li>
          ))}
        </ul>
      )}
    </Dialog>
  );
}
